export default function InputTheme() {

    const selectOverrides = () => ({
        fontSize: 16,
        icon: {
            color: "rgba(0,0,0,1)",
            right: 16,
        },
        iconFilled: {
            right: 16,
        },
    });

    return {
        components: {
            MuiInputBase: {
                styleOverrides: {
                    input: {
                        fontSize: 16,
                    },
                    root: {
                        height: 56,
                    },
                },
            },
            MuiFilledInput: {
                styleOverrides: {
                    root: {
                        backgroundColor: "rgba(0, 0, 0, 0.05)",
                    },
                    underline: {
                        "&::before": {
                            borderBottom: "solid 2px #b2b2b2",
                        },
                        "&:hover::before": {
                            borderBottomWidth: "2px",
                        },
                    },
                },
            },
            MuiFormLabel: {
                styleOverrides: {
                    root: {
                        fontSize: 16,
                        color: "rgba(0,0,0,0.6)",
                        '&.Mui-error': {
                            color: '#d32f2f',
                            fontSize: '17px',
                        },
                    }
                },
            },
            MuiFormHelperText: {
                styleOverrides: {
                    root: {
                        marginTop: 0,
                        paddingTop: 0,
                        '&.Mui-error': {
                            color: '#d32f2f !important',
                            fontSize: '13px',
                        },
                    },
                },
            },
            MuiInputLabel: {
                styleOverrides: {
                    shrink: {
                        color: "rgba(0,0,0,0.3) !important",
                    },
                    root: {
                        '&.Mui-error': {
                            fontSize: '17px',
                            fontWeight: 400,
                        },
                    }
                },
            },
            MuiSelect: {
                styleOverrides: selectOverrides(),
            },
            MuiNativeSelect: {
                styleOverrides: selectOverrides(),
            },
            MuiAutocomplete: {
                styleOverrides: {
                    endAdornment: {
                        display: "none"
                    },
                },
            },
        },
    };
}